<template>
    <!-- <div class="login">
        <div class="login-bg">
            <img src="../assets/images/login_home.png">
            <form>
                <div class="main">
                    <div class="main-title">
                        <i>涉税票证管理系统</i>
                    </div>
                    <div class="tipEl">
                        <div class="regTip" v-show="errortip">{{errortip}}</div>
                    </div>
                    <ul class="main-form">
                        <li><input type="text" :value="name" @input="setName" placeholder="用户名/手机号/电子邮箱"></li>
                        <li><input type="password" :value="pwd" @input="setPwd" placeholder="请输入密码"></li>
                    </ul>
                    <ul class="main-bottom">
                        <li class="register" @click="register_user()">注册新用户</li>
                        <li class="password" @click="modifypassword()">忘记密码</li>
                    </ul>
                    <div class="main-bn">
                        <span @click="handleLogin">登录</span>
                    </div>
                </div>
            </form>
        </div>
    </div> -->
    <div class="bg">
        <div class="contrainer">
            <img src="../assets/images/touming.png">
            <div class="login-wrap animated flipInY">
                <!-- <h3>登录</h3> -->
                <!-- <el-input type="text" v-model="name" @input="setName" placeholder="请输入用户名"></el-input>
                <el-input type="password" v-model="pwd" @input="setPwd" placeholder="请输入密码"></el-input> -->
                <el-form label-width="0px">
                    <el-form-item prop="name">
                        <!-- <el-input type="text" :value="name" @input="setName" placeholder="请输入用户名"></el-input> -->
                        <input @keyup.enter="login" type="text" :value="name" @input="setName" placeholder="请输入用户名">
                    </el-form-item>
                    <el-form-item prop="password">
                        <input @keyup.enter="login" type="password" :value="pwd" @input="setPwd" placeholder="请输入密码">
                    </el-form-item>
                    <el-form-item>
                        <el-row type="flex" justify="space-between">
                            <el-checkbox v-model="isMemery" style="color:#b1afaf">记住密码</el-checkbox>
                            <router-link to="/modifypassword" style="color:#5689ff">忘记密码？</router-link>   
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleLogin">登录</el-button>
                        <span @click="handleRegister" style="color:#5689ff;cursor:pointer;">注册新账号</span>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <vue-particles
            color="#fff"
            :particleOpacity="0.7"
            :particlesNumber="30"
            shapeType="star"
            :particleSize="5"
            linesColor="#fff"
            :linesWidth="2"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="3"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push"
        >
        </vue-particles>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'login',
    data(){
      return{
        isMemery:false
      }
    },
    computed:{
        ...mapGetters({
            name:'getName',
            pwd:'getPwd',
            errortip:'getErrorTip',
            permission: 'getPermission'
        }),
    },
    methods:{
        login(){
          console.log("11111")
        },
        //记住密码时触发
        setName(e){
            console.log(e)
            this.$store.commit('setName',e.target.value);   //用户名
        },
        setPwd(e){
            console.log(e)
            this.$store.commit('setPwd',e.target.value);  //密码
        },

        ...mapActions([
            'handleLogin','login',
        ]),
        // 注册
        handleRegister(){
            this.$router.push({
                path: "/register",
            });
        },
  },
}
</script>
<style scoped lang="scss">
.contrainer{
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 16%;
    align-items: flex-end;
}
input{
    -webkit-appearance: none;
    background-color: black;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: white;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}
.bg {
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('../assets/images/sky.jpg');
    background-position: -20% 10%;
    background-size: contain;
    #particles-js {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
}
.login-wrap {
	width: 97% !important;
    padding: 0 27px 0 20px;
    z-index: 3;
  .el-form-item {
    margin-bottom: 18px;
  }
  .el-form-item:nth-child(2) {
    margin-bottom: 0 !important;
  }
  h3 {
    text-align: center;
    color: #43464a;
    margin-top: 0px;
    margin-bottom: 5px;
    span {
        color: #5689ff;
    }
  }
  form {
	width: 100%;
    margin: 10px auto;
    .el-form-item {
      margin-bottom: 20px;
    }
    .el-form-item:nth-child(4){
        /deep/ .el-form-item__content{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            /deep/ .el-checkbox__label{
                color: #43464a;
            }
        }
    }
  }
  a {
    text-decoration: none;
    color: white;
  }
  button {
    width: 100%;
    font-weight: 600;
  }
}
.el-button + .el-button {
    margin: 10px 0 0 0;
}
input::-webkit-input-placeholder {
color: #757575;
}
input::-moz-input-placeholder {
color: #757575;
}
input::-ms-input-placeholder {
color: #757575;
}
</style>
